import { STYLES } from '@fiverr-private/locale_settings';

export const SOURCE = 'user-menu';
export const DEFAULT_STYLE = STYLES.MENU;
export const LINK_CLASSNAME = 'locale-settings-link';
export const LINK_TITLE_CLASSNAME = 'locale-settings-link-title';
